// extracted by mini-css-extract-plugin
export default {"root":"ServiceTerms_root__yYEuf","container":"ServiceTerms_container__cJTWF","list":"ServiceTerms_list__nkHGK"};